module.exports = __webpack_public_path__ + "img/afc-tnschoolfinder-03-trans.1c0484a3.png";